import { useMutation, useQueryClient } from '@tanstack/react-query';
import shallow from 'zustand/shallow';

import { applyVoucherCode } from '../queries';
import { useAuthStore, useShipToStore } from '../stores';
import { VOUCHER_LIST_KEY } from './useVoucherList';

export const useApplyVoucher = () => {
  const accessToken = useAuthStore((state) => state.access_token);
  const queryClient = useQueryClient();

  const [selectedShipToId] = useShipToStore(
    (s) => [s.selectedShipToId],
    shallow
  );

  return useMutation({
    mutationFn: (code: string) =>
      applyVoucherCode(accessToken, code, selectedShipToId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [VOUCHER_LIST_KEY] });
    },
  });
};
